import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";

// project-imports
import DrawerHeaderStyled from "./DrawerHeaderStyled";

import Logo from "components/logo";
import { HEADER_HEIGHT } from "config";
import { textAlign } from "../../../../../node_modules/@mui/system/index";

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
  const theme = useTheme();

  return (
    <DrawerHeaderStyled
      theme={theme}
      open={open}
      sx={{
        backgroundColor: "#ffffff",
        minHeight: HEADER_HEIGHT,
        width: "inherit",
        paddingTop: "2px",
        paddingBottom: "2px",
        paddingLeft: open ? "0px" : 0,
        
      }}
    >
      <h1
            // className="icertxBold"
            style={{
              textAlign: 'left',
              fontWeight: 'bold',
              color: '#E15B2C',
              fontFamily: 'poppins',
            margin:'0 auto'
            }}
          >
            ADMIN
          </h1>
    </DrawerHeaderStyled>
  );
};

DrawerHeader.propTypes = {
  open: PropTypes.bool,
};

export default DrawerHeader;
